import { httpClient } from '@/modules/common/services/http/http-client';
import { TradeButton } from './types';

const baseURL = `${process.env.VUE_APP_BFF_URL}/trading/`;
export const httpClientWithDefaultOptions = httpClient.withOptions({ baseURL });

export function getTradeCommonButtons(): Promise<TradeButton[]> {
  return httpClientWithDefaultOptions.get('v1/buttons/common');
}

export function getTradeSecuritiesLendingButtons(): Promise<TradeButton[]> {
  return httpClientWithDefaultOptions.get('v1/buttons/securities-lending');
}

export function getTradeMarginAllocationButtons(): Promise<TradeButton[]> {
  return httpClientWithDefaultOptions.get('v1/buttons/margin-allocation');
}

export function getTradeRLPButtons(): Promise<TradeButton[]> {
  return httpClientWithDefaultOptions.get('v1/buttons/rlp');
}

export function getTradeHomeBrokerButtons(): Promise<TradeButton[]> {
  return httpClientWithDefaultOptions.get('v1/buttons/home-broker');
}

export function getTradeCopyButtons(): Promise<TradeButton[]> {
  return httpClientWithDefaultOptions.get('v1/buttons/copy-trade');
}
